import script from "./slider-check.vue?vue&type=script&setup=true&lang=ts"
export * from "./slider-check.vue?vue&type=script&setup=true&lang=ts"

import "./slider-check.vue?vue&type=style&index=0&id=50719252&lang=css"

const __exports__ = script;

export default __exports__